import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import {AppService} from '../services/app.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
      private authService: AuthService,
      private appService: AppService,
      private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authService.logout();
                //location.reload(true);
                this.router.navigate(['/login']);
            }else if ( err.status === 400){
              console.log(err.error);
              this.appService.setError(err.error);
            }
            // console.log(err);

            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}
